import { createReducer } from 'redux-act';
import { setRootPath } from '../actions/global';
//[reducer] ../actions/{module_name}.jsで定義された内容を元に
//内部変数を変更する。
//component にて this.props.dispatch({actionName}());
//または
//redux-saga を使っている場合は ../saga/{module}.js から呼び出される。
//{actionName(param)} の引数param は props.dispatchで呼び出された場合は sagaに
// sagaで callによって呼び出されたときは reducer(このファイル)にて処理される。
//reducer を新規に作成した後は /reducer/index.js にも追記のこと。
//[actionName] :state =>
//[actionName] :(state,param) =>  ...{ationName(param)}
//[actionName] :() =>

//初期状態
export const server = 'gomono.kspot.net';
const initial = {
  global: {
    rootPath: '',
    appName: '合格ロケット',
    companyName: '建築イノベーション',
    server: server,
    appUrl: 'https://' + server + '/',
    wsUrl: 'wss://' + server + '/ws',
    siteUrl: 'https://5569et.com/',
    faqUrl: 'https://5569et.com/news200815-faq1/',
    dbVersion: 54,
    lastFetchTime: '2026-09-03 06:30',
    informationCount: 5,
    delayStudyHours: 3,
    searchMode: {
      0: { start: 0, span: 5, label: 'モードA', withYear: true },
      1: { start: 5, span: 7, label: 'モードB', withYear: true },
      2: { start: 12, span: 8, label: 'モードC', withYear: true },
      3: { start: 0, span: 20, label: '20年分', withYear: false },
    },
    tag: {
      warning: '数値',
      danger: '用語',
      primary: '単位',
      info: '公式',
      success: 'その他',
      black: '黒',
      white: '白',
    },
    payment: [
      { value: '1', label: '銀行振込' },
      { value: '2', label: 'クレジットカード' },
    ],
    prefectures: [
      '海外',
      '北海道',
      '青森県',
      '岩手県',
      '宮城県',
      '秋田県',
      '山形県',
      '福島県',
      '茨城県',
      '栃木県',
      '群馬県',
      '埼玉県',
      '千葉県',
      '東京都',
      '神奈川県',
      '新潟県',
      '富山県',
      '石川県',
      '福井県',
      '山梨県',
      '長野県',
      '岐阜県',
      '静岡県',
      '愛知県',
      '三重県',
      '滋賀県',
      '京都府',
      '大阪府',
      '兵庫県',
      '奈良県',
      '和歌山県',
      '鳥取県',
      '島根県',
      '岡山県',
      '広島県',
      '山口県',
      '徳島県',
      '香川県',
      '愛媛県',
      '高知県',
      '福岡県',
      '佐賀県',
      '長崎県',
      '熊本県',
      '大分県',
      '宮崎県',
      '鹿児島県',
      '沖縄県',
    ],
    //受験資格要件
    requirements: ['大学', '専門学校', '二級建築士', '建築設備士', 'その他'],
    //職域
    workField: [
      '建築士事務所',
      '建設業',
      '官公庁等',
      '住宅メーカー',
      '学生・研究生',
      'その他',
    ],
    //職務内容
    workType: [
      '建築設計',
      '施工管理・現場管理',
      '構造設計',
      '工事監理',
      '学生・研究生',
      'その他',
    ],
    //年代
    generation: [
      '20代前半',
      '20代後半',
      '30代前半',
      '30代後半',
      '40代前半',
      '40代後半',
      '50代以上',
      '回答したくない',
    ],
    appKnownRoot: [
      'ネット検索（勉強法等で検索）',
      'ネット検索（過去問の知識等で検索）',
      'ネット広告',
      'Youtube',
      'X',
      '教育的ウラ指導',
      '知人からの紹介',
      'その他',
    ],
    //購入の決め手になった理由
    buyReason: [
      'アプリの機能が魅力的だった',
      'アプリ以外のコンテンツ（Live講義・動画ライブラリー等）が魅力的だった',
      '通学しないで済むため',
      '個別相談やLINE等でのモチベーション管理サービスが魅力的だった',
      '最前線ニュースやメルマガ等の情報提供が魅力だった',
      'コスト',
      'その他',
    ],
    noteLists: [
      {
        id: 1,
        list: [
          '一級建築士試験教材アプリ代金',
          '一級建築士 学科試験対策講座代金',
          '資格取得支援サービス代金',
        ],
      },
      {
        id: 2,
        list: ['通信講座受講代金', 'オンライン講座代金'],
      },
    ],
    creditPayMethod: [
      { value: '1', label: '一括' },
      { value: '2', label: '分割' },
      { value: '5', label: 'リボルビング' },
    ],
    creditPayTimes: [
      { value: 2, label: '2回' },
      { value: 3, label: '3回' },
      { value: 6, label: '6回' },
      { value: 12, label: '12回' },
    ],
    workTimes: ['初回', '2 回', '3 回', '4 回', '5 回', '6 回以上'],
    studyType: ['独学', '学校併用'],
    marker: [
      'primary',
      'success',
      'warning',
      'danger',
      'info',
      'black',
      'white',
    ],
    progress: {
      success: '理解済',
      warning: '注意',
      danger: '保留',
    },
    playSpeed: {
      0: 'x1.3',
      1: 'x2.0',
      2: 'x2.8',
    },
    item_id: 1,
    testMode: [
      {
        id: 1,
        sheet_id: 3,
      },
      {
        id: 2,
        sheet_id: 12,
      },
      {
        id: 3,
        sheet_id: 27,
      },
      {
        id: 4,
        sheet_id: 101,
      },
      {
        id: 5,
        sheet_id: 37,
      },
      {
        id: 6,
        sheet_id: 53,
      },
      {
        id: 7,
        sheet_id: 64,
      },
    ],
    testModeExplanation: [
      {
        id: 1,
        sheet_id: 2,
      },
      {
        id: 2,
        sheet_id: 2,
      },
      {
        id: 3,
        sheet_id: 4,
      },
      {
        id: 4,
        sheet_id: 2,
      },
      {
        id: 5,
        sheet_id: 13,
      },
      {
        id: 6,
        sheet_id: 7,
      },
      {
        id: 7,
        sheet_id: 4,
      },
    ],
    answerCount: [
      { value: 1, label: '1回' },
      { value: 2, label: '2回' },
      { value: 3, label: '3回' },
      { value: 4, label: '4回' },
      { value: 5, label: '5回以上' },
    ],
    exam: [
      { label: '学科Ⅰ 計画', count: 20 },
      { label: '学科Ⅱ 環境・設備', count: 20 },
      { label: '学科Ⅲ 法規', count: 30 },
      { label: '学科Ⅳ 構造', count: 30 },
      { label: '学科Ⅴ 施⼯', count: 25 },
      /*
      { label: '学科Ⅰ 計画', count: 2 },
      { label: '学科Ⅱ 環境・設備', count: 2 },
      { label: '学科Ⅲ 法規', count: 3 },
      { label: '学科Ⅳ 構造', count: 3 },
      { label: '学科Ⅴ 施⼯', count: 2 },*/
    ],
  },
};

const global = createReducer(
  {
    [setRootPath]: (state, path) =>
      Object.assign({}, state, {
        rootPath: path,
      }),
  },
  initial.global
);

export default global;



// WEBPACK FOOTER //
// ./src/reducers/global.js